import { FC, useEffect, useRef, useState } from 'react';

import { CloseOutlined, LinkOutlined } from '@ant-design/icons';
import { Button, Drawer } from 'antd';
import { useNavigate } from 'react-router-dom';

import { routeNames } from '../../../constants/routes';
import { useActions } from '../../../hooks/useActions';
import { useTypedSelector } from '../../../hooks/useTypedSelector';

// Cache-buster timestamp нужно вставлять ДО якоря (#...), а не в конец.
// Иначе ссылка вида .../otchety/#41-... превращается в #41-...?timestamp=123,
// якорь не совпадает с id заголовка и страница не прокручивается к разделу.
const buildIframeSrc = (link: string): string => {
    if (!link) return link;
    const hashIndex = link.indexOf('#');
    const base = hashIndex === -1 ? link : link.slice(0, hashIndex);
    const hash = hashIndex === -1 ? '' : link.slice(hashIndex);
    const separator = base.includes('?') ? '&' : '?';
    return `${base}${separator}timestamp=${new Date().getTime()}${hash}`;
};

const GlobalModalsWrapper: FC = ({ children }) => {
    const navigate = useNavigate();
    const { isAboutReportOpen,drawerLink } = useTypedSelector((state) => state.app);
    const [ visible,setVisible ] = useState(isAboutReportOpen);
    const { setAppReportOpen,setDrawerLink } = useActions();
    useEffect(() => {
        if (isAboutReportOpen) {
            setVisible(isAboutReportOpen);
        }
    }, [ isAboutReportOpen ]);
    const onClose = () => {
        setAppReportOpen(false);
        setVisible(false);
    };
    const iframeRef = useRef(null);

    const openLink = () => {
        window.open(drawerLink, '_blank');
    };
    useEffect(() => {
        if(visible){
            const drawerBody = document.querySelector('.ant-drawer-body') as HTMLDivElement;
            const drawerHeader = document.querySelector('.ant-drawer-header') as HTMLDivElement;
            if (drawerBody) {
                drawerBody.style.padding = '0';
                drawerBody.style.overflow = 'hidden';
            }
            if(drawerHeader){
                drawerHeader.style.border = 'none';
                drawerHeader.style.display = 'none';
            }
            const postMessageToIframe = (data:string) => {
                const iframe = iframeRef.current;
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                if (iframe && iframe.contentWindow) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    //@ts-ignore
                    iframe.contentWindow.postMessage(data, 'https://lk.scananalytics.ru');
                }
            };
            postMessageToIframe('deleteElement');
        }
    });

    return <>
        <Drawer
            placement="right"
            onClose={onClose}
            open={visible}
            style={{ zIndex:1001 }}
            className="global-drawer"
            rootStyle={{ padding:0,overflow:'hidden',zIndex:1001 }}
        >
            <div style={{ position: 'absolute', top: 30, left: -40, zIndex: 1001 }}>
                <Button
                    icon={<CloseOutlined />}
                    onClick={onClose}
                    shape={'circle'}
                    style={{ display: 'block', marginBottom: 10 }}
                />
                <Button
                    icon={<LinkOutlined />}
                    onClick={openLink}
                    shape={'circle'}
                    style={{ display: 'block' }}
                />
            </div>
            <div style={{ marginTop:'10px' }}></div>
            <iframe
                className="help-iframe"
                ref={iframeRef}
                src={buildIframeSrc(drawerLink)}
            />
        </Drawer>
        {children}
    </>;
};

export default GlobalModalsWrapper;
